import { getAxiosInstance } from '@/apis/base.api';
import { logout } from './authSession';

let registered = false;

/**
 * 401 응답 시 authSession.logout 으로 세션 정리 (단일 진입점)
 */
export function registerAuthHttpInterceptor() {
  if (registered || typeof window === 'undefined') {
    return;
  }
  registered = true;

  const instance = getAxiosInstance();
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        logout();
      }
      return Promise.reject(error);
    }
  );
}
